import { render, staticRenderFns } from "./IconWithTooltip.vue?vue&type=template&id=28e9d000&scoped=true"
import script from "./IconWithTooltip.vue?vue&type=script&lang=ts"
export * from "./IconWithTooltip.vue?vue&type=script&lang=ts"
import style0 from "./IconWithTooltip.scss?vue&type=style&index=0&id=28e9d000&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e9d000",
  null
  
)

export default component.exports